import dashboardStyle from "./dashboardStyle";

/**
 * Currently used for article detail page, article list component used on `/news` and `/advice`, and some old demos.
 */
const employerDashboardStyle = (theme) => ({
  ...dashboardStyle(theme),
  contactForm: {
    marginTop: "1rem",
  },
  bg_colored: {
    backgroundColor: "#eaf6fe",
  },
});

export default employerDashboardStyle;
